import { AbstractControl, NG_VALIDATORS } from '@angular/forms'
import { Directive, Input } from '@angular/core';
import { DateService } from '../services/date.service';

@Directive({
  selector: '[minAge]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: MinAgeValidatorDirective, multi: true }
  ]
})
export class MinAgeValidatorDirective {
  @Input("minAge") minAge: number;

  constructor() { }

  ngOnInit() {
  }

  validate(c: AbstractControl) {
    let result: boolean = false;
    if (c.value == undefined || c.value == "")
      return null;
    else {
      result = this.isMinAge(c.value);
    }
    if (result) {
      return { 'minAge': true }
    }
    return null;
  }

  public isMinAge(inputDate: Date): boolean {
    let dateService = new DateService()
    let today: Date = new Date();
    return dateService.getCorrectDate(inputDate).getTime() > dateService.getCorrectDate(new Date(today.getFullYear() - this.minAge, today.getMonth(), today.getDate())).getTime();
  }
}